module.exports = __webpack_public_path__ + "files/145e1f6a66342aa476e0f9e73075b009.png";